export enum LayoutEnum {
    LayoutPrincipal = 1,
    LayoutEsquerda = 2,
    LayoutDireita = 3,
    LayoutPrincipalV2 = 4
}